module.exports = __webpack_public_path__ + "img/1.0c7ad59a.png";